export enum PRODUCT_CODES {
    CREDIT = 'CRA',
    POOLS = 'CRDPL',
    PLATFORM = 'USRPTF',
    LOANS = 'LOANS',
    COLLECTIONS = 'COLLECTIONS',
    COLENDING = 'CLNDNG',
}

export const USER_TYPES = {
    ADMIN: 'admin',
    PRODUCT: 'product',
    OPERATIONS: 'operations',
    CLIENT: 'client',
    CUSTOMER: 'customer',
    INTERNAL: 'internal',
    CPS: 'cps',
    INVESTOR: 'investor',
    AUDITOR: 'auditor',
    TREASURY: 'treasury',
    TRUSTEE: 'trustee',
    LAW_FIRM: 'law_firm',
    RATING_AGENCY: 'rating_agency',
    CLIENT_ACQUISITION_GROUP: 'client_acquisition_group',
    CLIENT_SERVICE_GROUP: 'client_service_group',
    CREDIT: 'credit',
    INSTITUTIONAL_BUSINESS: 'institutional_business',
    CAPITAL_MARKETS: 'capital_markets',
    RISK: 'risk',
    GUARANTOR: 'guarantor',
    COLLATERAL_MANAGER: 'collateral_manager',
    INTERNAL_AUDITOR: 'internal_auditor',
    ARRANGER: 'arranger',
    MAKER: 'psl_operations_–_maker',
    CHECKER: 'psl_operations_–_checker',
    RELATIONSHIP_MANAGER: 'relationship_managers_role',
    LENDER: 'lender',
    COLLECTION_AGENCY: 'collection_agency',
    ANCHOR: 'anchor',
    VENDOR: 'vendor',
};

export const GROUPS = {
    PRODUCT: 'product',
    INVESTOR: 'investor',
    CLIENT: 'customer',
    CAG: 'client_acquisition_group',
    RISK: 'risk',
    TREASURY: 'treasury',
    VENDOR: 'vendor',
    COLLATERAL_MANAGER: 'collateral_manager',
    ANCHOR: 'anchor',
    RETAIL_USER: 'retail_user',
    CONNECTOR: 'connector',

    CAPITAL_MARKETS: 'capital_markets',
    OPERATIONS: 'operations',
    CREDIT: 'credit',
    CLIENT_SERVICE_GROUP: 'client_service_group',
    CREDIT_COMMITTEE: 'credit_committee',
    INTERNAL_AUDITOR: 'internal_auditor',
    CUSTOMER: 'customer',
    TRUSTEE: 'trustee',
    REGISTRAR: 'registrar',
};

export const INTERNAL_ACTORS = [
    { value: 'product', label: 'Product' },
    { value: 'institutional_business', label: 'Institutional Business' },
    { value: 'capital_markets', label: 'Digital Capital Markets' },
    { value: 'operations', label: 'Operations' },
    { value: 'risk', label: 'Risk' },
    { value: 'treasury', label: 'Treasury' },
    { value: 'credit', label: 'Credit' },
    { value: 'client_acquisition_group', label: 'Client Aquisition Group' },
    { value: 'client_service_group', label: 'Client Service Group' },
    { value: 'internal_auditor', label: 'Internal Auditor' },
];

export const ALLOCATION_ENGINE_ROLE = {
    BUSINESS_UNIT_ADMIN: 'bu_admin',
    BRANCH_ADMIN: 'branch_admin',
    BRANCH_MEMBER: 'branch_member',
    ENTITY_ADMIN: 'entity_admin',
    ADMIN: 'admin',
};
